export const CYBLOG_LOG_SHOW = 'cyblog_show';

export const CYBLOG_BROADCAST_CHANNEL_NAME = 'CYBLOG_BROADCST_CHANNEL';

export const CYBLOG_CONSOLE_PARAMS_DEFAULT = {
  thread: 'all',
  unit: 'all',
  module: 'all',
};
